// src/components/Common/ConfirmModal.jsx
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from '@mui/material';
import { Close, Warning, Info, Error, CheckCircle } from '@mui/icons-material';

const ConfirmModal = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmColor = 'primary',
  variant = 'warning', // 'warning', 'error', 'info', 'success'
  loading = false,
}) => {
  const getIcon = () => {
    switch (variant) {
      case 'error':
        return <Error color="error" sx={{ fontSize: 40 }} />;
      case 'success':
        return <CheckCircle color="success" sx={{ fontSize: 40 }} />;
      case 'info':
        return <Info color="info" sx={{ fontSize: 40 }} />;
      default:
        return <Warning color="warning" sx={{ fontSize: 40 }} />;
    }
  };

  const getIconColor = () => {
    switch (variant) {
      case 'error':
        return 'error.50';
      case 'success':
        return 'success.50';
      case 'info':
        return 'info.50';
      default:
        return 'warning.50';
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={!loading ? onClose : undefined}
      maxWidth="xs" 
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
        }
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" component="div">
            {title}
          </Typography>
          {!loading && (
            <IconButton onClick={onClose} size="small">
              <Close />
            </IconButton>
          )}
        </Box>
      </DialogTitle>

      <DialogContent sx={{ py: 2 }}>
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              bgcolor: getIconColor(),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {getIcon()}
          </Box>
          
          <Typography 
            variant="body1" 
            textAlign="center"
            sx={{ color: 'text.primary' }}
          >
            {message}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={loading}
          sx={{ minWidth: 80 }}
        >
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color={confirmColor}
          disabled={loading}
          sx={{ minWidth: 80 }}
        >
          {loading ? 'Processing...' : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;